import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import menu from './menu.reducer';
import cart from './cart.reducer';
import checkout from './checkout.reducer';
import common from './common.reducer';
import restaurant from './restaurant.reducer';
import sidebar from './sidebar.reducer';
import mailing from './mailing.reducer';

const reducer = combineReducers({
    menu,
    cart,
    checkout,
    common,
    restaurant,
    sidebar,
    mailing
});

export default reducer;